import { _WorkActivity } from "../../../../../core/services/dataBean/EntityCatalog";
import { Section } from "../Section/Section";
import { BacklogActivities } from "./BacklogActivities/BacklogActivities";
import { useState } from "react";

interface PropsSprintSection {
}

export function BacklogSection({ }: PropsSprintSection) {

    const [expanded, setExpanded] = useState<boolean>(false);

    return (
        <>
            <Section title={"Tareas sin Asignar"} expanded={expanded} onToggle={() => { setExpanded(prev => !prev) }}  >
                {expanded && (
                    <BacklogActivities />
                )}
            </Section>
        </>
    );
}